import { createContext, useContext, useState, useEffect } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem("token"));

  useEffect(() => {
    const checkAuth = async () => {
      const savedToken = localStorage.getItem("token");
      if (savedToken) {
        try {
          const response = await api.get("/auth/me");
          setUser(response.data);
          setToken(savedToken);
        } catch (error) {
          localStorage.removeItem("token");
          setUser(null);
          setToken(null);
        }
      }
      setLoading(false);
    };
    checkAuth();
  }, []);

  const login = async (email, password) => {
    const response = await api.post("/auth/login", { email, password });
    const { token: newToken, user: userData } = response.data;
    localStorage.setItem("token", newToken);
    setToken(newToken);
    setUser(userData);
    return userData;
  };

  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
    setUser(null);
  };

  const isAdmin = user?.role === "admin" || user?.role === "admin_vendedor";
  const isLogistica = user?.role === "logistica" || user?.role === "vendedor_logistica";
  const isVendedor = user?.role === "vendedor" || user?.role === "vendedor_logistica";
  const isVendedorLogistica = user?.role === "vendedor_logistica";
  const canManageAssignments = isAdmin || isLogistica;
  const canViewFinances = isAdmin;
  const canManageUsers = isAdmin;

  return (
    <AuthContext.Provider value={{
      user,
      token,
      loading,
      login,
      logout,
      isAdmin,
      isLogistica,
      isVendedor,
      isVendedorLogistica,
      canManageAssignments,
      canViewFinances,
      canManageUsers
    }}>
      {children}
    </AuthContext.Provider>
  );
};
